import { Box, Divider, Stack, Typography } from "@mui/material";
import LoadingButton from "@/components/common/buttons/loadingButton";
import TextButton from "@/components/common/buttons/textButton";
import { AffirmInlineLogo } from "@/components/common/paymentPlans/affirmLogo";
import { GREY, INDIGO } from "@/config/mui/colorPalette";
import { formattedPrice } from "@/utils";

export default function OnlineStoreCheckoutActions({
  totalPrice,
  isLoading,
  goToCheckout,
  isMobile = false,
  onGiftModalOpen,
  cherryIntegrationV1Enabled,
}: {
  totalPrice: number;
  isLoading: boolean;
  goToCheckout: () => void;
  isMobile?: boolean;
  onGiftModalOpen: () => void;
  cherryIntegrationV1Enabled: boolean;
}) {
  return (
    <Box>
      <Stack
        direction="row"
        sx={{
          bgcolor: GREY[5],
          px: 1.5,
          py: 1,
          borderRadius: "8px",
          mb: 2,
          mt: isMobile ? 2 : 4,
        }}
      >
        <Typography variant="labelSmall">Cart total:</Typography>
        <Typography variant="h3" sx={{ ml: 1 }}>
          {formattedPrice(totalPrice)}
        </Typography>
      </Stack>
      {cherryIntegrationV1Enabled && <AffirmAdditionalInfo />}
      {isMobile && <Divider sx={{ mb: 2 }} />}
      <LoadingButton
        fullWidth
        loading={isLoading}
        variant="contained"
        onClick={goToCheckout}
        sx={{ mb: 1 }}
        size="small"
      >
        Checkout
      </LoadingButton>
      <TextButton
        onClick={onGiftModalOpen}
        fullWidth
        sx={{ py: 0.5, mt: 0.5, mb: isMobile ? 0 : 7 }}
      >
        Buy as a gift
      </TextButton>
    </Box>
  );
}

const AffirmAdditionalInfo = () => {
  return (
    <Stack
      sx={{
        mb: 2,
        gap: 1,
        p: "8px 12px",
        borderRadius: "8px",
        backgroundColor: INDIGO[20],
        flexDirection: "row",
      }}
    >
      <AffirmInlineLogo withName={false} />
      <Typography variant="paragraphSmall">
        Split the total into multiple payments. Option available at checkout.
      </Typography>
    </Stack>
  );
};
